import RadarChart from './RadarChart';
import ContentRomResult from './ContentRomTableResult';
import ContentRomResultSides from './ContentROMTableResultSides';
import { Flex, Row, Col, Typography, Avatar, QRCode } from 'antd';
import './style.css';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import MobilityPersonas from './MobilityPersonna';
import MobilityOverview from './MobilityOverview';
import { getMobilityData } from '@stores/constants';
import { useEffect, useState } from 'react';
import { useTypedSelector } from '@stores/index';
import { evalScore } from './jointsTemplateData';
import LogoWithFallback from '@atoms/AdminMenu/LogoMark';
import PieChart from './PieChart';
import OldRadarChart from './OldRadarChart';
const { Title, Text } = Typography;

const DownloadResults = ({ selectedRom, chartType }) => {
	const { t } = useTranslation();
	const [avgScore, setAvgScore] = useState(0);
	const mobilityOptions = getMobilityData(Math.round(avgScore), t);
	const persona = mobilityOptions.find(option => option.active);
	const getColorForCategory = (score: number) => {
		if (Math.round(score) >= 90) return '#52c41a';
		if (Math.round(score) >= 75 && Math.round(score) <= 89) return '#73D13D';
		if (Math.round(score) >= 60 && Math.round(score) <= 74) return '#faad14';
		if (Math.round(score) >= 40 && Math.round(score) <= 59) return '#F59712';
		if ( Math.round(score) >= 20 && Math.round(score) <= 39) return '#F2615B';
		return '#d9363e';
	};
	const { selectedUser } = useTypedSelector((state) => state.contacts.main)
	const user = useTypedSelector(state => state.user);

	const calculateAge = (birthdate: Date) => {
		const today = new Date();
		const birthdateDate = new Date(birthdate);
		let age = today.getFullYear() - birthdateDate.getFullYear();
		const monthDiff = today.getMonth() - birthdateDate.getMonth();
		if (
			monthDiff < 0 ||
			(monthDiff === 0 && today.getDate() < birthdateDate.getDate())
		) {
			age--;
		}
		return age;
	};

	useEffect(() => {
  if (selectedRom?.romPatientResults) {
    const totalScore = selectedRom?.romPatientResults?.reduce((sum: number, item: { results: {score: number}[]; }) => {
      const itemScore = item?.results?.reduce((innerSum: number, result: { score: number; }) => {
        const score = Math.round(evalScore(result));
        return innerSum + (score > 100 ? 100 : score);
      }, 0);
      return sum + (itemScore || 0);
    }, 0);
const totalResultsLength = selectedRom?.romPatientResults?.reduce(
  (total: number, item: { results: { score: number }[] }) => total + (item.results?.length || 0),
  0
);
	setAvgScore(Math.round(totalScore / totalResultsLength))
  }
}, [selectedRom]);


	const formatBirthdate = (birthdate: Date) => {
		if (!birthdate) return 'N/A';
		const birthdateDate = new Date(birthdate);
		const age = calculateAge(birthdateDate);
		return (
			<span>
				{`${age}`} {t('Admin.data.managePatient.yearsOld')}
			</span>
		);
	};

	const getCategoryName = (score: number) => {
		if (score >= 90) return t('Patient.data.omnirom.optimalMobility');
		if (score >= 75) return t('Patient.data.omnirom.functionalMobility');
		if (score >= 60) return t('Patient.data.omnirom.moderateRestriction');
		if (score >= 40) return t('Patient.data.omnirom.limitedMobility');
		if (score >= 20) return t('Patient.data.omnirom.restrictedMobility');
		return t('Patient.data.omnirom.criticallyImpaired');
	};

	const getCategoryDesc = (score: number) => {
		if (score >= 90) return t('Patient.data.omnirom.optimalMobilityDesc');
		if (score >= 75) return t('Patient.data.omnirom.functionalMobilityDesc');
		if (score >= 60) return t('Patient.data.omnirom.moderateRestrictionDesc');
		if (score >= 40) return t('Patient.data.omnirom.limitedMobilityDesc');
		if (score >= 20) return t('Patient.data.omnirom.restrictedMobilityDesc');
		return t('Patient.data.omnirom.criticallyImpairedDesc');
	};

	return (
		<div style={{ margin: 40, backgroundColor: 'var(--summary-bg-colors)' }}>
			<div className="mobility-report-physio-data pdf-section flex justify-between items-center">
				<div className="logo-mark">
					<LogoWithFallback download={true}/>
				</div>
				<div className="flex items-center gap-4 w-[100%] justify-end">
					<div>
						<QRCode
							value={window.location.href}
							size={100}
						/>
					</div>
					<div>
						<p className={`inter-heading-bold pdf-margin`}>
							{t('Patient.data.mobilityReport.mobilityProgressReport')}
						</p>
						<p className={`inter-text-regular-sm  pdf-margin`}>
							{t('Patient.data.mobilityReport.reportCreated')} : {user?.profile?.fullName}
						</p>
						<p className={`inter-text-regular-sm  pdf-margin`}>
							{new Date().toLocaleDateString('en-GB')}
						</p>
					</div>
				</div>
				<div className="user-info-container">
					<Avatar
						style={{
							backgroundColor: user?.profile?.avatarColor || '#1890FF',
							color: '#FFF',
							fontSize: '52px',
							border: '4px solid white',
							display: 'inline-flex',
							alignItems: 'start',
							marginTop: '20px',
						}}
						alt="avatar"
						size={100}>
						<p className="pdf-margin -mt-5">
							{user?.isPhysioterapist ? selectedUser?.profile?.firstName?.charAt(0)?.toUpperCase() : user?.profile?.firstName?.charAt(0)?.toUpperCase() || 'U'}
						</p>
					</Avatar>
					<div className="user-info">
						<div className="text-end">
							<span
								style={{
									fontSize: '20px',
									lineHeight: '1.75rem',
									fontWeight: 700,
								}}>
								<p>{user?.isPhysioterapist ? selectedUser?.profile?.fullName : user?.profile?.fullName}</p>
							</span>
							<div className="user-metric-data">
								<p style={{ fontSize: '14px', lineHeight: '1rem' }}>
									<p style={{ fontSize: '14px', lineHeight: '1rem' }}>
										{t('Patient.data.mobilityReport.birthDate')} : {user.profile.birthDate}
									</p>
									<div style={{ fontSize: '15px' }}>
										<span
											style={{
												marginTop: '-1px',
												textTransform: 'capitalize',
											}}>
											{user?.profile?.gender || 'N/A'},{' '}
										</span>
										<span>{formatBirthdate(user?.profile?.birthDate)}</span>
									</div>
									<span style={{ fontSize: '14px', lineHeight: '1rem' }}>
										<span style={{ fontSize: '14px', lineHeight: '1rem' }}>
											{t('Patient.data.mobilityReport.weight')} :{' '}
											{user?.profile?.imperialWeight
												? `${user?.profile?.weight[0]?.imperialWeight} lbs `
												: `${user?.profile?.weight[0]?.metricWeight} kg `}
										</span>
										<span style={{ fontSize: '14px', lineHeight: '1rem' }}>
											| {t('Patient.data.mobilityReport.height')}: {user?.profile?.imperialHeight}"
										</span>
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Flex vertical>
				<Row className="pdf-section">
					<Col flex="auto">
						<Title
							type="secondary"
							level={4}
							style={{ display: 'flex', alignItems: 'end', gap: 10 }}>
							<p>{t('Patient.data.omnirom.romMobilityReport')}</p>
							<p>- {selectedRom?.romProgram?.title}</p>
						</Title>
					</Col>
					<Col flex="180px">
						<Text type="secondary">
							{moment(selectedRom?.createdAt).local().format('LLL')}
						</Text>
					</Col>
				</Row>
				<Row gutter={16} className="pdf-section">
					<Col
						span={12}
						style={{
							padding: '10px',
							backgroundColor: 'white',
							borderRadius: '14px',
						}}>
					<div className="flex rounded-lg p-4 mb-4 items-center justify-center gap-2" style={{ backgroundColor: "#f2f4f7" }}>
							<div className="mobility-icon">
								<img src={persona?.selectedIcon} alt={persona?.title} />
							</div>
							<div className="mobility-text">
								<div
									className={`mobility-title-text pdf-margin`}
									style={{ color: persona?.color }}>
									{t('Patient.data.mobilityReport.youAre')} "{persona?.title?.toUpperCase()}"
								</div>
								<div className={`mobility-description pdf-margin`}>
									{persona?.range}
								</div>
							</div>
						</div>
						{chartType === 'radar' ? 
						<OldRadarChart selectedRom={selectedRom} persona={persona!} avgScore={avgScore} isPdf/>
					: <PieChart selectedRom={selectedRom} persona={persona!} avgScore={avgScore} isPdf/> }
						</Col>
					<Col span={12}>
						<ContentRomResultSides
							isPdf
							selectedRom={selectedRom}
							getColorForCategory={getColorForCategory}
							getCategoryName={getCategoryName}
							getCategoryDesc={getCategoryDesc}
						/>
					</Col>
				</Row>
				<MobilityOverview
					isPdf
					persona={{
						color: '',
					}}
				/>
				<ContentRomResult
					isPdf
					selectedRom={selectedRom}
					getColorForCategory={getColorForCategory}
					getCategoryName={getCategoryName}
				/>
				<MobilityPersonas isPdf avgScore={avgScore} />
			</Flex>
		</div>
	);
};

export default DownloadResults;
